export default __webpack_public_path__ + "static/media/info.23c13dff.svg";